import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=e2d4980a&scoped=true&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"
import style0 from "./advertising.vue?vue&type=style&index=0&id=e2d4980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d4980a",
  null
  
)

export default component.exports